module.exports = __webpack_public_path__ + "img/Welcome.6318e636.jpg";